export default __webpack_public_path__ + "static/media/PagalogoOnly.de591abb.svg";